import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { Layout } from '.';
import CourseCard from '../components/CourseCard';
import { Progress } from '../components';

@inject('CourseStore') @observer
export default class Courses extends Component{
  componentWillMount() {
    const { CourseStore } = this.props;
    CourseStore.fetch();
  }

  render() {  
    const { CourseStore } = this.props;
    return (
      <Layout footerStyle={{backgroundColor: '#FFF'}}>
        <div>
          <section className="novidades listagem main">
            {CourseStore.isLoading && <Progress />}
            {!CourseStore.isLoading && (
              <duv>
                <div className="noticias-filtro">
                  <ul className="categorias-noticias">
                    <li>
                      <button className={!CourseStore.categoryId ? 'active' : ''} onClick={() => CourseStore.clearFilterCategory()}>Todas</button>
                    </li>
                  { CourseStore.categories.map(category => (
                    <li key={`category${category.id}`}>
                      <button className={CourseStore.categoryId === category.id ? 'active' : ''} onClick={() => CourseStore.filterCategory(category.id)}>{category.name}</button>
                    </li>
                  ))}
                  </ul>
                </div>
                <div className="cursos">
                  <ul>
                  { CourseStore.items.map(course => (
                    <li key={`course${course.id}`}>
                      <CourseCard 
                        course={course}
                      />
                    </li>
                  ))}
                    
                  </ul>
                </div>
              </duv>
            )}
          </section>
        </div>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Courses.js